import axiosClient from "./axiosClient";

const postApi = {
    getBlogPosts(queryString) {
        const baseURL = `post/get_post?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    deleteBlogPost(postId) {
        return axiosClient.post("post/delete_post", { postId });
    },

    // --- Quản lý bình luận ---
    getAllComments(queryString) {
        return axiosClient.get(`post/get_all_comments?${queryString || ""}`);
    },
    replyComment(commentId, comment) {
        // Dùng chung endpoint /new_reply: tự thông báo cho chủ bình luận được trả lời
        return axiosClient.post("post/new_reply", { commentId, comment });
    },
    deleteComment(commentId) {
        return axiosClient.post("post/delete_comment", { commentId });
    },
    deleteReply(replyId) {
        return axiosClient.post("post/delete_reply", { replyId });
    },
    bulkDeleteComments(commentIds) {
        return axiosClient.post("post/delete_comments_bulk", { commentIds });
    },
    // Duyệt bình luận/trả lời đang chờ duyệt (kiểm duyệt chống spam)
    approveComments(commentIds) {
        return axiosClient.post("post/approve_comments_bulk", { commentIds });
    },
    approveReplies(replyIds) {
        return axiosClient.post("post/approve_replies_bulk", { replyIds });
    },
    // Từ cấm kiểm duyệt: comment chứa từ cấm tự vào hàng chờ duyệt
    getBannedWords() {
        return axiosClient.get("post/banned_words");
    },
    updateBannedWords(words) {
        return axiosClient.put("post/banned_words", { words });
    },
    // Giới hạn tốc độ bình luận: số cmt/giờ mỗi user (chống spam)
    getCommentLimit() {
        return axiosClient.get("post/comment_limit");
    },
    updateCommentLimit(limit) {
        return axiosClient.put("post/comment_limit", { limit });
    },
    getVideoList(queryString) {
        const baseURL = `post/get_video_list?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    getVideoCategories() {
        const baseURL = `post/get_video_categories`;
        return axiosClient.get(baseURL);
    },
    createVideoList(videoList) {
        const baseURL = `post/new_video_list`;
        return axiosClient.post(baseURL, { videoList });
    },
    updateVideoList(videoId, data) {
        const baseURL = `post/update_video_list`;
        return axiosClient.post(baseURL, {
            videoId,
            ...data,
        });
    },
    deleteVideoList(videoId) {
        const baseURL = `post/delete_video_list`;
        return axiosClient.post(baseURL, { videoId });
    },

    // --- Categories ---
    createVideoCategories(categoryList) {
        return axiosClient.post(`post/new_video_categories`, { categoryList });
    },
    updateVideoCategory(categoryId, categoryName) {
        return axiosClient.post(`post/update_video_categories`, {
            categoryId,
            categoryName,
        });
    },
    deleteVideoCategory(categoryId) {
        return axiosClient.post(`post/delete_video_categories`, { categoryId });
    },

    // --- Video ↔ products (Shopee) ---
    resolveProduct(url) {
        return axiosClient.post(`post/resolve_product`, { url });
    },
    createVideoWithProducts(payload) {
        // { url, productName, categoryId, products: [{ url }] }
        return axiosClient.post(`post/new_video_with_products`, payload);
    },
    updateVideoProducts(videoId, products) {
        return axiosClient.post(`post/update_video_products`, {
            videoId,
            products,
        });
    },
    recheckVideoProducts(videoIds) {
        return axiosClient.post(`post/recheck_video_products`, { videoIds });
    },
    recheckAllVideoProducts(limit) {
        return axiosClient.post(`post/recheck_all_video_products`, { limit });
    },

    // --- Video link (alive/dead + metadata) ---
    resolveVideo(url) {
        return axiosClient.post(`post/resolve_video`, { url });
    },
    recheckVideoLinks(videoIds) {
        return axiosClient.post(`post/recheck_video_links`, { videoIds });
    },
    recheckAllVideoLinks(limit) {
        return axiosClient.post(`post/recheck_all_video_links`, { limit });
    },
    deleteVideoListBulk(videoIds) {
        return axiosClient.post(`post/delete_video_list_bulk`, { videoIds });
    },
    updateVideoListBulk(videoIds, categoryId) {
        return axiosClient.post(`post/update_video_list_bulk`, {
            videoIds,
            categoryId,
        });
    },
};

export default postApi;
